// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"InsurerLogoWrapper__wrapper___3lQs-","logo":"InsurerLogoWrapper__logo___2AovN"};